import { render } from "./ProspectsOptions.vue?vue&type=template&id=21e4866b"
import script from "./ProspectsOptions.vue?vue&type=script&lang=js"
export * from "./ProspectsOptions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__